import {AfterViewChecked, ChangeDetectorRef, Component, forwardRef, HostBinding} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {PackingUnit} from "../../../shared/view-model/store-management/packing-unit.type";
import {appInjector} from "../../../index";
import {Packing} from "../../../shared/view-model/store-management/packing.type";
import {PackingUnitService} from "../../services/packing-unit/packing-unit.service";
import {CURRENCY_ERRORS} from "../../../core/visbos-core/ui/components/currency-input/currency-input.component";

@Component({
  selector: 'vb-packing-form',
  templateUrl: './packing-form.component.html',
  styleUrls: ['./packing-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => PackingFormComponent)}]
})
export class PackingFormComponent extends AbstractVisbosControl<Packing, FormGroup> implements AfterViewChecked {

  @HostBinding('class')
  classBinding = 'form';

  CURRENCY_ERRORS;

  priceLabel = "Stückpreis";

  public setDefaultValues(item?: Packing): { [controlKey: string]: any } | any {

    if (item && item.packing_amount && item.packing_amount > 1) {
      this.control.addControl('packing_amount', this.fb.control(null, Validators.required))
    }

    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      article_number: this.setValue(item, 'article_number'),
      packing_amount: this.setValue(item, 'packing_amount'),
      packing_price: this.setValue(item, 'packing_price'),
      default_packing: this.setValue(item, 'default_packing'),
    }
  };

  packingUnitList = [];
  hasContent = false;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, private puService: PackingUnitService) {
    super(fb, cd, null);
    this.CURRENCY_ERRORS = CURRENCY_ERRORS;
  }

  ngOnInit() {
    super.ngOnInit();
    this.puService.getPackingUnitList().subscribe((pus: any) => {
      this.packingUnitList = pus;
    });
  }

  ngAfterViewChecked(): void {
    let puId = this.control.get('packing_unit_id').value;
    let pu = this.packingUnitList.find(pu => pu.cuid === puId);
    if (puId && pu) {
      this.hasContent = pu ? pu.has_content : false;
    }
    if (this.hasContent) {
      this.control.addControl('packing_amount', this.fb.control(this.setValue(this.item, 'packing_amount'), Validators.required))
    } else {
      this.control.removeControl('packing_amount');
    }
    this.priceLabel = (pu && pu.packing_unit_name) ? "Preis pro " + pu.packing_unit_name : "Preis";

    this.cd.detectChanges();
  }

  buildControlContent(values?: Packing): FormGroup {
    return PackingFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null, values?: Packing): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null, Validators.required],
      article_number: [null],
      default_packing: [null],
      packing_unit_id: [null, Validators.required],
      packing_price: [null],
    });
  }

  onPackingUnitChanged(pu: PackingUnit) {

  }


}



// WEBPACK FOOTER //
// ./src/app/store-management/product/packing-form/packing-form.component.ts